import NewsletterTenContainer from "./containers/NewsletterTenContainer";
export default NewsletterTenContainer;
